import { useGetLocationGroupsLazy } from '@occc-app/dataAccessLayer/locationGroup/queries';
import { LazyAutocompleteField } from '@occc/ui-design-system';

import {
  mapLocationGroupsQueryResponseToRawArray,
  mapRawLocationGroupResponseItemToAutocompleteOption,
} from '../AddToLocationGroupDialog/utils';
import { LocationGroupSelectItem } from '../AddToLocationGroupDialog/types';

export const LocationGroupMultiSelect = () => (
  <LazyAutocompleteField<
    LocationGroupSelectItem,
    ReturnType<typeof useGetLocationGroupsLazy>['response']
  >
    name='locationGroups'
    label='Add location to group'
    useLazyQuery={useGetLocationGroupsLazy}
    mapQueryResponseToRawArray={mapLocationGroupsQueryResponseToRawArray}
    mapRawResponseItemToAutocompleteOption={mapRawLocationGroupResponseItemToAutocompleteOption}
    inputProps={{ margin: 'none' }}
    first={100}
  />
);
